import { z } from "zod";
import { customerOperationsOpaqueIdSchema } from "./customer-operations-core.js";
import { adminSupportWorkspaceSchemaVersionSchema } from "./admin-operations-support-workspace.js";
import { commercialEntitlementStateSchema, commercialPurchaseIntentSchema, } from "./channel-commerce.js";
/** Only a ticket locator. Never a payer, voucher hash/code, order or account search. */
export const adminSupportPurchaseContextCommandSchema = z
    .object({
    schemaVersion: adminSupportWorkspaceSchemaVersionSchema,
    ticketId: customerOperationsOpaqueIdSchema,
    view: z.literal("PURCHASE_CONTEXT"),
})
    .strict();
export const adminSupportPurchaseContextResponseSchema = z
    .object({
    data: z
        .object({
        schemaVersion: adminSupportWorkspaceSchemaVersionSchema,
        ticketId: customerOperationsOpaqueIdSchema,
        context: z.discriminatedUnion("state", [
            z
                .object({
                state: z.literal("UNAVAILABLE"),
                reasonCode: z.enum(["NO_BOOK", "NOT_LINKED", "UNVERIFIED_LINK", "PURCHASER_PRIVACY"]),
            })
                .strict(),
            z
                .object({
                state: z.literal("AVAILABLE"),
                channel: z.enum(["DIRECT", "QVC"]),
                purchaseIntent: commercialPurchaseIntentSchema,
                entitlementState: commercialEntitlementStateSchema,
                includedPrintCopies: z.literal(1),
                retailUnitPosition: z.number().int().positive().max(100).nullable(),
                paymentStatus: z.literal("NOT_VERIFIED"),
                voucherLookup: z.literal("INTERNAL_ID_NOT_RAW_CODE"),
                orderMeaning: z.literal("COMMERCIAL_ORDER_NOT_PHYSICAL_ORDER"),
            })
                .strict(),
        ]),
    })
        .strict(),
})
    .strict();
//# sourceMappingURL=admin-operations-support-purchase.js.map